import HomePage from "./HomePage";

export default HomePage;

export * from "./HomePage";
